import { CheckmarkIcon } from "@smartsheet/ursa-icons";
import classNames from "classnames";
import React, { forwardRef, ReactNode } from "react";
import { MenuItem } from "../menu";

export interface TabMenuItemProps {
    /**
     * The children to render inside this TabMenuItem
     */
    children: ReactNode;
    /**
     * The id of the tab
     */
    id: string;
    /**
     * Whether the tab is selected or not
     */
    selected: boolean;
    /**
     * Whether the tab is disabled or not
     */
    isDisabled?: boolean;
    /**
     * The function to call when the tab is clicked
     */
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    /**
     * The function to call when a key is pressed
     */
    onKeyDown?: (event: React.KeyboardEvent<HTMLButtonElement>) => void;
}

export const TabMenuItem = forwardRef<HTMLButtonElement, TabMenuItemProps>(
    (
        { isDisabled, onClick, onKeyDown, id, selected, children, ...rest },
        ref: React.ForwardedRef<HTMLButtonElement>
    ) => {
        return (
            <MenuItem
                ref={ref}
                onClick={onClick}
                onKeyDown={onKeyDown}
                id={id}
                role="tab"
                isDisabled={isDisabled}
                contentBefore={
                    <>
                        {selected && (
                            <span className="sds-tab-menu-item-checkmark">
                                <CheckmarkIcon
                                    color="var(--smar--com--color--icons--primary--strong, #2D60D7)"
                                    size={20}
                                />
                            </span>
                        )}
                    </>
                }
                {...rest}
            >
                <span className={classNames(`sds-tab-menu-items-container`, selected && `is-selected`)}>
                    {children}
                </span>
            </MenuItem>
        );
    }
);

TabMenuItem.displayName = "TabMenuItem";
